import { useState } from 'react'
import useSWRInfinite from 'swr/infinite'
import internalApiQueryWrapper from '../../network/internalApiQueryWrapper'
import { STORIES_PER_PAGE } from '../../utils/constants'
import loadMore from '../../utils/loadMore'
import Metadata from '../Metadata'
import Button from '../StoryCollection/Button'
import Card from '../StoryCollection/Card'
import AuthorHeader from './AuthorHeader'
import style from '../../styles/components/author/author'

const AuthorDetails = ({ author, collection }) => {
  const [storyCollection, setStoryCollection] = useState(collection?.stories)
  const [skip, setSkip] = useState(STORIES_PER_PAGE)

  const { data, error, isLoading } = useSWRInfinite(
    () => ({
      url: `/api/collection`,
      args: { skip, authorId: author?.id }
    }),
    internalApiQueryWrapper
  )

  return (
    <>
      <Metadata />
      <div className='container'>
        <AuthorHeader author={author} />
        <div className='container'>
          {storyCollection?.map((story) => (
            <div key={story.slug} className='card-container'>
              <Card story={story} cardType='text-card' />
            </div>
          ))}
        </div>
        {storyCollection?.length < collection.total && !error && (
          <Button
            label='Show More'
            loading={isLoading}
            onClick={() =>
              loadMore({
                data: data?.flat(),
                setStoryCollection,
                setSkip
              })
            }
          />
        )}
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default AuthorDetails
